import { useRef } from 'react';

/**
 * Minimal horizontal swipe detection for touch view-modes (lightbox, carousels).
 * Swiping left fires onSwipeLeft (→ next); swiping right fires onSwipeRight (→ prev).
 * Returns handlers to spread onto the swipeable element.
 */
export function useSwipe(onSwipeLeft: () => void, onSwipeRight: () => void, threshold = 50) {
  const startX = useRef<number | null>(null);

  return {
    onTouchStart: (e: React.TouchEvent) => {
      startX.current = e.touches[0].clientX;
    },
    onTouchEnd: (e: React.TouchEvent) => {
      if (startX.current === null) return;
      const dx = e.changedTouches[0].clientX - startX.current;
      if (Math.abs(dx) > threshold) {
        if (dx < 0) onSwipeLeft();
        else onSwipeRight();
      }
      startX.current = null;
    },
  };
}
